import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component';

export interface SharedDialogOptions {
  titleIcon?: string;
  titleIconColor?: 'primary' | 'secondary' | 'danger';
  confirmText?: string;
  confirmIcon?: string;
  confirmButtonStyle?: 'primary' | 'danger';
  confirmIconPosition?: 'start' | 'end';
  cancelText?: string;
  cancelButtonStyle?: 'secondary' | 'danger';
  size?: 'small' | 'medium' | 'large';
  hideHeader?: boolean;
  hideConfirm?: boolean;
  customConfirmButton?: boolean;
}

@Component({
  selector: 'app-shared-dialog',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, ButtonComponent],
  templateUrl: './shared-dialog.component.html',
  styleUrls: ['./shared-dialog.component.scss'],
})
export class SharedDialogComponent implements OnInit {
  @Input() title!: string;
  @Input() options: SharedDialogOptions = {
    titleIcon: '',
    titleIconColor: 'secondary',
    confirmText: '',
    confirmIcon: '',
    confirmButtonStyle: 'primary',
    confirmIconPosition: 'start',
    cancelText: '',
    cancelButtonStyle: 'secondary',
    size: 'medium',
    hideHeader: false,
    hideConfirm: false,
    customConfirmButton: false,
  };

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  get width() {
    switch (this.options.size) {
      case 'small':
        return '400px';
      case 'medium':
        return '600px';
      case 'large':
        return '900px';
      default:
        return '600px';
    }
  }

  onCancel() {
    this.cancel.emit();
  }

  onConfirm() {
    this.confirm.emit();
  }
}
